import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-bulk-result',
    templateUrl: './bulk-result.component.html',
    styleUrls: ['./bulk-result.component.scss'],
    standalone: false
})
export class BulkResultComponent implements OnInit {
  // visible = true;
  successCount = 0;
  errorCount = 0;
  errorMessages: string[] = [];
  isErrorDetailsOpen = true;
  entityType = '';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.successCount = this.config.data?.success?.length || 0;
    this.errorCount = this.config.data?.errors?.length || 0;
    this.errorMessages = this.config.data?.errors || [];
    this.entityType = this.config.data?.entityType
    
  }

  ngOnInit(): void {
  }

  toggleErrorDetails() {
    this.isErrorDetailsOpen = !this.isErrorDetailsOpen;
  }

  closeDialog() {
    this.ref.close(); 
  }
  
}
